
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetogoaurbaniaonrent() {



  const cardData =
  {
    keyword: ' Pune to Goa Urbania on Rent',
    heading: 'Vaishnavi Travels: Pune to Goa Urbania on Rent',
    headingDescription: 'Vaishnavi Travels offers premium and affordable Pune to Goa Urbania on Rent, perfect for family vacations, corporate outings, school tours, and group getaways. Our Force Urbania is well-maintained with spacious push-back seats, powerful air-conditioning, modern interiors, and ample luggage space, ensuring a smooth and comfortable ride on the long Pune–Goa route. With professional chauffeurs, timely pickups, and flexible booking options, we make your coastal journey hassle-free and enjoyable. Whether it’s a holiday trip, beach vacation, or special occasion, Vaishnavi Travels guarantees safe, reliable, and luxurious Urbania rental services from Pune to Goa.',

    top: 'Top Places to Visit in Goa with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Baga Beach is Goa’s most vibrant and happening beach, famous for water sports, nightlife, and beach shacks. Tourists enjoy parasailing, jet skiing, and banana boat rides during the day. As the sun sets, the beach comes alive with music, dance, and clubs like Tito’s and Mambo’s. Families love the lively yet safe vibe here. The seafood served at beach shacks adds to the charm. Baga Beach is Goa’s entertainment hub for fun and relaxation."
  },
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, known as the ‘Queen of Beaches,’ is the largest and one of the most popular beaches in North Goa. It is crowded with tourists enjoying sunbathing, swimming, and shopping. The beach is lined with shacks serving Goan delicacies and refreshing drinks. Water sports like windsurfing and parasailing attract thrill-seekers. The bustling market nearby adds a shopping element to the visit. Calangute is Goa’s lively seaside paradise for all age groups."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is one of Goa’s most revered churches. Built in 1605, it houses the mortal remains of St. Francis Xavier. The baroque architecture, intricate carvings, and gilded altars mesmerize visitors. Pilgrims from around the world come here to offer prayers. The church is also an architectural and historical wonder. Basilica of Bom Jesus is Goa’s sacred heritage of faith and history."
  },
  {
    "title": "Aguada Fort",
    "description": "Aguada Fort, built in 1612 by the Portuguese, stands tall overlooking the Arabian Sea. It once served as a strategic defense fort and a freshwater supply point for ships. The lighthouse inside is a major attraction, offering panoramic views of the coastline. Tourists enjoy exploring its bastions and walls while soaking in sea breezes. The fort is a favorite spot for photography and history lovers. Aguada Fort is Goa’s proud sentinel of maritime history."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, located on the Goa-Karnataka border, is one of India’s tallest waterfalls, cascading from a height of 310 meters. Its name means ‘Sea of Milk,’ inspired by the white frothy water gushing down. Visitors reach it via jeep safaris or treks through the Bhagwan Mahavir Sanctuary. The monsoon makes it a breathtaking sight with roaring waters. Adventure lovers also spot trains passing near the falls. Dudhsagar is Goa’s natural wonder of power and beauty."
  },
  {
    "title": "Anjuna Flea Market",
    "description": "The Anjuna Flea Market is Goa’s most famous shopping destination, held every Wednesday. It offers clothes, jewelry, handicrafts, and souvenirs from across India and abroad. Street performances, music, and international cuisines create a vibrant vibe. Tourists love bargaining for unique items and soaking in the hippie culture. The market reflects Goa’s blend of tradition and modernity. Anjuna Flea Market is Goa’s colorful hub of culture and shopping."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach in South Goa is known for its crescent-shaped shoreline, calm waters, and scenic beauty. It is less crowded than North Goa beaches, making it perfect for couples and families. Tourists enjoy kayaking, dolphin-spotting boat rides, and yoga retreats here. Colorful beach huts along the shore add to the charm. The relaxed vibe makes it ideal for long stays. Palolem Beach is Goa’s serene and picturesque seaside escape."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, perched on a hill near Vagator Beach, is famous for its panoramic views of the Arabian Sea. Built by the Portuguese in 1617, the fort gained popularity after being featured in the Bollywood movie ‘Dil Chahta Hai.’ Tourists enjoy hiking up to the fort for stunning sunsets. Its ruined walls and open landscapes offer excellent photography opportunities. Chapora Fort is Goa’s blend of history, cinema, and scenic beauty."
  },
  {
    "title": "Colva Beach",
    "description": "Colva Beach, stretching for 2.4 km in South Goa, is one of the oldest and most famous beaches. Known for its soft white sand and coconut palms, it offers peace compared to busier northern beaches. Visitors enjoy swimming, beach walks, and seafood at local shacks. The nearby Our Lady of Mercy Church adds spiritual significance. Evenings at Colva are filled with beautiful sunsets. Colva Beach is Goa’s traditional coastal retreat."
  },
  {
    "title": "Se Cathedral",
    "description": "Se Cathedral in Old Goa is one of the largest churches in Asia, dedicated to St. Catherine. Built in Portuguese-Manueline style, it reflects grandeur with its tall façade, gilded altars, and exquisite paintings. The church also houses the famous Golden Bell, known for its rich sound. Pilgrims and history lovers flock here to admire its spiritual and architectural significance. Its vast interiors create an awe-inspiring experience. Se Cathedral is Goa’s monumental symbol of faith and heritage."
  }
],


      "services": [
    {
      "name": "Urbania Rental Pune to Goa",
      "description": "Experience a comfortable and scenic journey from Pune to Goa with our reliable Urbania rental service. Our 13/17 seater Urbania vans are perfectly suited for family vacations, group tours, and corporate outings. Enjoy spacious seating, powerful air conditioning, and ample luggage space for a hassle-free trip to the beautiful beaches and vibrant culture of Goa. With experienced drivers who know the best routes, you can relax and enjoy the ride without any worries. Book now for a memorable Goa getaway starting right from Pune."
    },
    {
      "name": "AC Urbania Goa Trip Pune",
      "description": "Travel in cool comfort on your Pune to Goa trip with our fully air-conditioned Urbania vans. Designed to provide a premium travel experience, these vans come equipped with ergonomic seats, individual AC vents, and noise reduction features to ensure a relaxing journey. Whether it's a family vacation or a corporate retreat, the AC Urbania van keeps the interior cool and refreshing even during long road trips through scenic highways and coastal routes."
    },
    {
      "name": "Luxury Urbania for Goa Travel",
      "description": "Upgrade your Pune to Goa travel experience with our luxury Urbania vans featuring plush interiors, leather seating, ambient lighting, and advanced entertainment systems. Ideal for VIP groups, honeymooners, or special occasions, this van offers unmatched comfort and style. Additional perks include chilled beverages, onboard Wi-Fi, and a courteous chauffeur dedicated to making your journey smooth and enjoyable. Perfect for those who want to travel in elegance and class."
    },
    {
      "name": "13/17 Seater Urbania for Goa",
      "description": "Our 13 and 17 seater Urbania vans provide the ideal balance of space and maneuverability for group travel from Pune to Goa. Suitable for medium-sized groups, these vans offer ample legroom, adjustable seats, and plenty of storage for luggage and beach gear. Whether you’re heading to Goa for a weekend trip, a beach festival, or a corporate outing, this Urbania rental service ensures everyone travels together comfortably."
    },
    {
      "name": "Force Urbania Pune Goa Weekend Plan",
      "description": "Plan your perfect weekend escape from Pune to Goa with our Force Urbania vans designed for road trips. These vehicles combine rugged build quality with modern comfort, making them ideal for scenic drives along coastal highways. Benefit from features like GPS navigation, spacious interiors, and driver expertise in handling long-distance trips, allowing your group to focus on enjoying Goa’s beautiful beaches, nightlife, and culinary delights."
    },
    {
      "name": "Goa Road Trip Urbania Van",
      "description": "Make your Goa road trip memorable with our Urbania vans that prioritize passenger comfort and convenience. Equipped with adjustable seats, climate control, and ample window space for sightseeing, these vans are perfect for families, friends, and corporate groups. Enjoy seamless stops along the way with flexible trip planning and a driver who ensures safe, timely, and efficient travel throughout your Goa adventure."
    },
    {
      "name": "Pune to Goa Group Travel Urbania",
      "description": "Travel as a group from Pune to Goa in style and comfort with our specially tailored Urbania rental service. Designed for groups attending festivals, weddings, corporate retreats, or family vacations, these vans allow everyone to travel together without multiple vehicles. Enjoy features like onboard charging ports, comfortable seating, and easy communication with the driver to make group coordination smooth and hassle-free."
    },
    {
      "name": "Outstation Urbania Goa Hire",
      "description": "Rent our Outstation Urbania vans for your Goa trip from Pune and experience a hassle-free long-distance travel option. These vans come with professional drivers, flexible trip schedules, and a commitment to passenger safety. Equipped to handle various road conditions, the vans provide consistent performance and comfort across the entire journey, ensuring you reach Goa relaxed and ready to enjoy your holiday."
    },
    {
      "name": "Urbania Goa Beach Tour from Pune",
      "description": "Combine transportation and touring with our Urbania Goa Beach Tour service from Pune. Perfect for beach lovers and nature enthusiasts, this service offers pick-up and drop-off along with guided stops at famous Goan beaches like Baga, Calangute, Anjuna, and Palolem. Travel comfortably in our spacious vans while soaking in the coastal views and exploring Goa’s diverse culture and cuisine."
    },
    {
      "name": "Urbania Van for Corporate Goa Trip",
      "description": "Organize efficient and comfortable corporate travel from Pune to Goa with our dedicated Urbania van rental. Ideal for corporate retreats, team-building exercises, and business conferences held in Goa, this service provides reliable vehicles with onboard amenities like Wi-Fi, charging ports, and ample space for work materials. Our professional drivers ensure punctuality and safe transit, allowing your team to focus on productivity and relaxation."
    },
    {
      "name": "Couple Goa Travel in Urbania",
      "description": "Enjoy a romantic getaway from Pune to Goa in our comfortable and private Urbania vans designed for couples. Whether you’re celebrating an anniversary, honeymoon, or just a peaceful trip, our service provides a serene travel environment with spacious seating, controlled climate, and privacy options. Customize your trip with personalized stops and flexible schedules, making your Goa trip truly special and memorable."
    },
    {
      "name": "Urbania with Driver to Goa",
      "description": "Make your Pune to Goa journey effortless with our Urbania vans available with experienced, courteous drivers. Our drivers are well-versed with the Pune-Goa route and ensure timely, safe, and smooth travel. This full-service package allows passengers to relax and enjoy the trip without worrying about navigation or road conditions. Additional driver services include assistance with luggage, route customization, and local recommendations in Goa."
    },
    {
      "name": "Book Urbania Pune to Goa Online",
      "description": "Conveniently book your Urbania van for Pune to Goa travel online through our user-friendly platform. Select from various van sizes, AC or non-AC options, and rental durations to suit your travel needs. Online booking ensures instant confirmation, competitive pricing, and access to customer support for any trip adjustments. Plan your Goa trip stress-free and secure your Urbania rental from Pune with just a few clicks."
    }
  ],
  "tableData": [
    ["Urbania Rental Pune to Goa", "AC Urbania Goa Trip Pune"],
    ["Luxury Urbania for Goa Travel", "13/17 Seater Urbania for Goa"],
    ["Force Urbania Pune Goa Weekend Plan", "Goa Road Trip Urbania Van"],
    ["Pune to Goa Group Travel Urbania", "Outstation Urbania Goa Hire"],
    ["Urbania Goa Beach Tour from Pune", "Urbania Van for Corporate Goa Trip"],
    ["Couple Goa Travel in Urbania", "Urbania with Driver to Goa"],
    ["Book Urbania Pune to Goa Online"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Urbania on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Force Urbania rentals for the Pune to Goa route, ideal for group vacations, corporate trips, and family holidays."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Urbania vans provide plush seats, ample legroom, and air conditioning to make your long journey from Pune to Goa relaxing and enjoyable."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each vehicle is regularly serviced and thoroughly cleaned to ensure safety, hygiene, and comfort throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Route",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with the Pune-Goa route, ensuring timely and safe travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental options tailored to your travel itinerary and group size."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes for a hassle-free booking experience."
  },
  {
    "WhyChooseheading": "Perfect for Family Vacations, Corporate Retreats, and Group Tours",
    "WhyChoosedescription": "Ideal for leisure travel, business trips, and sightseeing tours between Pune and Goa."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]
























  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for Pune to Goa trips?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for rent on Pune to Goa routes, ideal for group vacations, family trips, and corporate tours to Goa.',
    },
    {
      question: 'What features does the 13 seater Force Urbania offer for Pune to Goa travel?',
      answer: 'The 13 seater Force Urbania comes with spacious seating, air-conditioning, comfortable legroom, modern interiors, and ample luggage space to ensure a comfortable and enjoyable long-distance journey to Goa.',
    },
    {
      question: 'Are the vehicles and drivers reliable for Pune to Goa rentals?',
      answer: 'Absolutely! All vehicles are regularly serviced and well-maintained. Our experienced and courteous drivers are familiar with the Pune-Goa route, ensuring a safe and timely trip.',
    },
    {
      question: 'What is the rental cost for a Pune to Goa trip in a 13 seater Force Urbania?',
      answer: 'Rental costs for Pune to Goa trips typically start from ₹8,000, depending on trip duration, distance, and any additional services requested.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for return trips between Pune and Goa?',
      answer: 'Yes, Vaishnavi Travels offers flexible options for one-way and return trips between Pune and Goa with clear and transparent pricing.',
    },
    {
      question: 'How early should I book a 13 seater Urbania for Pune to Goa travel?',
      answer: 'Booking at least 4-5 days in advance is recommended, especially during peak holiday seasons, to ensure vehicle availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to Goa Force Urbania rentals?',
      answer: 'Yes, flexible pickup and drop locations are available in Pune, Goa, and nearby areas to best suit your travel itinerary.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rohan Mehta",
    position: "Vacation Planner",
    feedback:
      "Our Pune to Goa trip with Vaishnavi Travels’ 13 seater Urbania was fantastic. The vehicle was comfortable, air-conditioned, and spacious, and the driver was professional and punctual.",
    rating: 5,
  },
  {
    name: "Ms. Anjali Desai",
    position: "Tourist",
    feedback:
      "We had a smooth and enjoyable journey from Pune to Goa thanks to Vaishnavi Travels. The Urbania was perfect for our group and handled the long trip comfortably.",
    rating: 5,
    style: "style-2",
  }
];



































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Urbania on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-goa-urbania-rental.jpg",
  "description": "Rent luxury Force Urbania (13/17 seater) for your Pune to Goa trip. Perfect for group travel, corporate trips, beach tours, and weekend getaways with AC comfort and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.92",
    "ratingCount": "478"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-goa-urbania-on-rent"
  }
};



  return (
    <div>


<Helmet>
  <title>Pune to Goa Urbania on Rent | Luxury 13 & 17 Seater AC Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent luxury Force Urbania (13/17 seater) for your Pune to Goa trip. Perfect for group travel, corporate trips, beach tours, and weekend getaways with AC comfort and experienced drivers."
  />
  <meta
    name="keywords"
    content="Urbania Rental Pune to Goa, AC Urbania Goa Trip Pune, Luxury Urbania for Goa Travel, 13/17 Seater Urbania for Goa, Force Urbania Pune Goa Weekend Plan, Goa Road Trip Urbania Van, Pune to Goa Group Travel Urbania, Outstation Urbania Goa Hire, Urbania Goa Beach Tour from Pune, Urbania Van for Corporate Goa Trip, Couple Goa Travel in Urbania, Urbania with Driver to Goa, Book Urbania Pune to Goa Online"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoaurbaniaonrent;